import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  DASHBOARD: {
    path: `${baseRoutes.adminBaseRoutes}/dashboard`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon-grid-square-circle" />
      </span>
    ),
  },
};

export default accessRoute;
